/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF, AsyncPipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './@core/auth/auth.service';
import { environment } from '../environments/environment';
import { NbToastrModule, NbGlobalPhysicalPosition, NbDatepickerModule, NbDialogModule, NbIconModule, NbLayoutModule } from '@nebular/theme';
import { Cloudinary as CloudinaryCore } from 'cloudinary-core';
// import { CloudinaryConfiguration, CloudinaryModule } from '@cloudinary/angular-5.x';
import { AuthModule } from './pages/auth/auth.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KwSpinnerModule } from './@theme/directives/kw-spinner.module';
import { SharedService } from './shared/shared.service';
import { SHARED_SERVICE } from './shared/mockSharedService';
import { CloudinaryModule } from '@cloudinary/ng';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FormsModule } from '@angular/forms';
import { ChangeTenantComponent } from './shared/change-tenant/change-tenant.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BaseChartDirective } from 'ng2-charts';
import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { AppHttpInterceptor } from './@core/http.interceptor';
// import { PDFService } from './harvest-engine/modules/contracts/services/pdf.service';
// import { SignalrIntegrationsHubService } from './harvest-engine/core/signalr/signalr-integrations-hub.service';
// import {AngularFireAuthModule} from '@angular/fire/auth'
// import { AngularFireMessagingModule } from '@angular/fire/messaging';
// import {AngularFireModule } from '@angular/fire'
// import { MessagingService } from './service/firebase-service';


export const cloudinary = {
  Cloudinary: CloudinaryCore
};
// export const cld_config: CloudinaryConfiguration = environment;

// Define an initializer function
// export function initializePdfService(pdfService: PDFService) {
//   return () => pdfService.initialize();
// }

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [AppComponent,ChangeTenantComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FontAwesomeModule,
    AuthModule,
    KwSpinnerModule,
    NgbModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbDialogModule.forRoot(),
    NbLayoutModule,
    // ToastrModule.forRoot(),
    NbToastrModule.forRoot({position: NbGlobalPhysicalPosition.BOTTOM_RIGHT}),
    NbDatepickerModule.forRoot(),
    // CloudinaryModule.forRoot(cloudinary, cld_config),
    CloudinaryModule,
    MatTableModule,
    FormsModule,
    MatPaginatorModule,
    MatSortModule,
    NbEvaIconsModule,
    NbIconModule,
    // LottieAnimationViewModule.forRoot(),
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    LottieModule.forRoot({ player: playerFactory })
    // LottieModule.forRoot({ player: playerFactory }),
    // LottieAnimationViewModule.forRoot(),
    // AngularFireAuthModule,
    // AngularFireMessagingModule,
    // AngularFireModule.initializeApp(environment.firebase)
  ],
  // entryComponents: [
  //   ChangeTenantComponent
  // ],
  bootstrap: [AppComponent],
  providers: [
    // PDFService,
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializePdfService,
    //   deps: [PDFService],
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: SHARED_SERVICE, useClass: SharedService },
    provideEnvironmentNgxMask(),
    BaseChartDirective,
    // provideLottieOptions({
    //   player: () => player,
    // })
    // MessagingService,
    // AsyncPipe
  ],
})

export class AppModule {
}
